import { render, staticRenderFns } from "./inputsTabletable.vue?vue&type=template&id=8071ca9c&"
import script from "./inputsTabletable.vue?vue&type=script&lang=js&"
export * from "./inputsTabletable.vue?vue&type=script&lang=js&"
import style0 from "./inputsTabletable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports